import { motion } from 'framer-motion';
import { PROJECTS } from './data';

// HOME — case-study folio. Massive case-numbers, no full-bleed parallax.
// Top: typographic studio statement. Below: 3 numbered case-study folios stacked.
export default function Home({ setPage }) {
  return (
    <div className="bg-[#F0EBE0] text-[#1B2D8C]">
      {/* TOP STATEMENT — large numeric folio */}
      <section className="pt-32 pb-12 max-w-[1500px] mx-auto px-8 lg:px-14">
        <div className="grid lg:grid-cols-[auto_1fr] gap-12 items-end">
          <p className="font-serif text-[120px] sm:text-[180px] lg:text-[280px] leading-[0.78] text-[#FFC700] tabular-nums">N°<span className="italic">047</span></p>
          <div>
            <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1B2D8C] mb-4">— Folio of work · 2014 — 2026</p>
            <h1 className="font-serif text-4xl sm:text-6xl lg:text-7xl tracking-[-0.02em] leading-[1.02] text-[#1B2D8C]">
              A six-person studio for the<br /><span className="italic">one client a quarter</span> who needs<br />a serious identity system.
            </h1>
            <p className="font-sans text-base text-[#1B2D8C]/65 mt-6 max-w-2xl leading-[1.7]">We design brand systems and the digital products that carry them. We take four projects a year. Engagements run five to fourteen months. Our investment threshold is $180k.</p>
            <div className="flex flex-wrap items-center gap-4 mt-8">
              <button onClick={() => setPage('work')} data-testid="vsp-home-cta" className="bg-[#1B2D8C] text-[#FFC700] px-7 py-3.5 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#FFC700] hover:text-[#1B2D8C] transition-colors">View 24 case studies →</button>
              <button onClick={() => setPage('brief')} className="font-mono text-[10px] tracking-[0.32em] uppercase border-b-2 border-[#1B2D8C] text-[#1B2D8C] pb-1 hover:text-[#FFC700] hover:border-[#FFC700]">Or send a brief →</button>
            </div>
          </div>
        </div>
      </section>

      {/* CLIENT BAR — diagonal yellow strip */}
      <section className="bg-[#FFC700] border-y-[3px] border-[#1B2D8C] py-5">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 flex flex-wrap items-baseline gap-x-10 gap-y-2 font-serif italic text-[#1B2D8C] text-lg lg:text-2xl">
          <span className="font-mono text-[10px] not-italic tracking-[0.4em] uppercase shrink-0">— Selected clients —</span>
          {['Halcyon Watches', 'Mira Health', 'Avalon Yachts', 'Sterling Asset', 'Blackstone Property', 'Helio Energy'].map(c => <span key={c}>{c}</span>)}
        </div>
      </section>

      {/* THREE CASE-STUDY FOLIOS — each a numbered spread */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 space-y-20">
        {PROJECTS.slice(0, 3).map((p, i) => (
          <motion.article key={p.code} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className={`grid lg:grid-cols-[300px_1fr] gap-10 items-start ${i % 2 ? 'lg:grid-cols-[1fr_300px]' : ''}`}>
            <div className={`${i % 2 ? 'lg:order-2 lg:text-right' : ''}`}>
              <p className="font-serif text-[140px] lg:text-[220px] leading-[0.78] text-[#1B2D8C] tabular-nums">{String(i + 1).padStart(2, '0')}</p>
              <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1B2D8C]/55 mt-3">Case · {p.code}</p>
              <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FFC700] bg-[#1B2D8C] inline-block px-2 py-0.5 mt-2">{p.sector}</p>
            </div>
            <div className={i % 2 ? 'lg:order-1' : ''}>
              <div className="aspect-[16/10] overflow-hidden border-[3px] border-[#1B2D8C] mb-5">
                <img src={p.img} alt="" className="w-full h-full object-cover" loading="lazy" />
              </div>
              <p className="font-serif italic text-3xl lg:text-5xl leading-[1.04]" dangerouslySetInnerHTML={{ __html: p.client + ' — ' + p.t }} />
              <p className="font-sans text-base text-[#1B2D8C]/65 mt-3 leading-[1.7]">{p.t1}</p>
              <div className="grid grid-cols-3 gap-6 mt-6 pt-5 border-t border-[#1B2D8C]/20 font-mono text-[10px] tracking-[0.32em] uppercase text-[#1B2D8C]/65">
                <div><p>Year</p><p className="font-serif text-xl normal-case tracking-normal text-[#1B2D8C] mt-1">{p.year}</p></div>
                <div><p>Engagement</p><p className="font-serif text-xl normal-case tracking-normal text-[#1B2D8C] mt-1">{p.months} mo.</p></div>
                <div><p>Status</p><p className="font-serif italic text-xl normal-case tracking-normal text-[#FFC700] bg-[#1B2D8C] inline-block px-2 mt-1">Live</p></div>
              </div>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
